// Browser Notification Utilities for VibeTalk

import { isChatSoundEnabled, playNotificationSound as playChatSound } from './soundUtils';

let swRegistration = null;

const playNotificationSound = () => {
  if (!isChatSoundEnabled()) return;
  playChatSound();
};

/**
 * Register the service worker and request notification permission
 */
export const initNotifications = async () => {
  if (!('Notification' in window) || !('serviceWorker' in navigator)) {
    return false;
  }

  try {
    swRegistration = await navigator.serviceWorker.register('/serviceWorker.js');

    if (Notification.permission === 'default') {
      await Notification.requestPermission();
    }

    return Notification.permission === 'granted';
  } catch (error) {
    console.error('Notification init error:', error);
    return false;
  }
};

/**
 * Show a browser notification for an incoming message.
 * Uses the service worker registration so it works even when the tab is in the background.
 *
 * @param {string} senderName - Nickname of the sender
 * @param {string} messagePreview - Short preview of the message body
 * @param {string} [tag] - Notification tag to collapse duplicates per sender
 */
export const showMessageNotification = (senderName, messagePreview, tag) => {
  if (Notification.permission !== 'granted') return;

  const title = `${senderName} sent a message`;
  const options = {
    body: messagePreview || 'New message',
    icon: '/favicon.svg',
    badge: '/favicon.svg',
    tag: tag || `msg-${senderName}`,
    renotify: true
  };

  playNotificationSound();
  if (swRegistration) {
    swRegistration.showNotification(title, options);
  } else {
    // Fallback to basic Notification API
    new Notification(title, options);
  }
};

/**
 * Show a browser notification for a match event.
 */
/**
 * Show notification for incoming video call.
 */
export const showCallNotification = (callerName) => {
  if (Notification.permission !== 'granted') return;

  const title = 'Incoming video call 📹';
  const options = {
    body: `${callerName} is calling you`,
    icon: '/favicon.svg',
    badge: '/favicon.svg',
    tag: 'call-notification',
    renotify: true,
    requireInteraction: true
  };

  playNotificationSound();
  if (swRegistration) {
    swRegistration.showNotification(title, options);
  } else {
    new Notification(title, options);
  }
};

export const showMatchNotification = (partnerName) => {
  if (Notification.permission !== 'granted') return;

  const title = "It's a Match! 🎉";
  const options = {
    body: `You matched with ${partnerName}`,
    icon: '/favicon.svg',
    badge: '/favicon.svg',
    tag: 'match-notification',
    renotify: true
  };

  playNotificationSound();
  if (swRegistration) {
    swRegistration.showNotification(title, options);
  } else {
    new Notification(title, options);
  }
};
